// extracted by mini-css-extract-plugin
export var pointContainer = "service-document-container-module--pointContainer--2emVA";
export var picture = "service-document-container-module--picture--IFpL0";
export var etc = "service-document-container-module--etc--3zG4_";
export var pointContainer__header = "service-document-container-module--pointContainer__header--1qTRA";